interface Props {
  color?: string
  width?: number
  height?: number
}

export const RectangleIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="20" height="20" rx="1.5" stroke={color} />
    </svg>
  )
}
